import React, { useState } from "react";
import { Document, Page } from "react-pdf";

export default function PdfAllPages(props) {
  const [numPages, setNumPages] = useState(null);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const { pdf } = props;

  return (
    <Document
      file={pdf}
      options={{ workerSrc: "/pdf.worker.js" }}
      onLoadSuccess={onDocumentLoadSuccess}
    >
        {/* <br/> */}
        {Array.from(new Array(numPages), (el, index) => (
            <div>                
                <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                <br/>
            </div>
        ))}
    </Document>
  );
}
